export const SIGNED_FLOW_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

/**
 * Parse backend date string as UTC (ISO 8601).
 * If the string ends with a timezone (Z or ±hh:mm / ±h:mm / ±hhmm), use as-is; otherwise append Z and treat as UTC.
 */
export function parseUtcDate(dateString: string): number {
  const s = dateString.trim();
  if (!s) return NaN;
  if (!/(?:Z|[+-]\d{1,2}(?::?\d{1,2})?)$/.test(s)) {
    return new Date(s + "Z").getTime();
  }
  return new Date(s).getTime();
}

/** Compute signed-flow timer end (10 min after dateLastStateUpdate or from now if missing/invalid). */
export function getSignedFlowExpiration(
  integration: { dateLastStateUpdate?: string } | null | undefined
): number {
  const parsedLastUpdate = integration?.dateLastStateUpdate
    ? parseUtcDate(integration.dateLastStateUpdate)
    : NaN;
  const baseTime = Number.isNaN(parsedLastUpdate) ? Date.now() : parsedLastUpdate;
  return baseTime + SIGNED_FLOW_TIMEOUT_MS;
}
